import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useEffect, useState } from 'react';

import Check from '@/assets/svg/bx-check.svg?react';
import Clone from '@/assets/svg/bx-copy.svg?react';
import { Button } from '@/components/buttons';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/Tooltip';
import { Text, type TextProps } from '@/components/typography';

const CopyToClipboardText = ({ value, ...rest }: TextProps) => {
  const [copied, setCopied] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    if (copied) {
      const timeoutId = window.setTimeout(() => {
        setCopied(false);
        setIsTooltipOpen(false);
      }, 3000);

      return () => {
        window.clearTimeout(timeoutId);
      };
    }
  }, [copied]);

  const handleCopy = () => {
    if (value) {
      setCopied(true);
      navigator.clipboard.writeText(value + '');
    }
  };

  return (
    <div className="flex items-center justify-center gap-2" data-testid="clipboard-copy-text">
      <Text {...rest} value={value} />
      <Tooltip open={copied || isTooltipOpen} onOpenChange={setIsTooltipOpen}>
        <TooltipTrigger
          render={
            <Button
              variant="ghost"
              size="icon-small"
              aria-label={t`Copy text to clipboard`}
              onClick={handleCopy}
            >
              {copied ? <Check /> : <Clone />}
            </Button>
          }
        />
        <TooltipContent>
          {copied ? <Trans>Copied!</Trans> : <Trans>Copy to clipboard</Trans>}
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export default CopyToClipboardText;
